import React from 'react';
import styled from 'styled-components';
import { useFormikContext } from 'formik';
import { H1 } from 'components/text';
import { FieldGroup, RadioButton, TextArea } from 'components/forms';
import { individual_questions, entity_questions } from './questions';

// not very attractive but it gets the job done
const IndentTextArea = styled.div`
  margin-left: 20px;
`

const BackgroundInfo = () => {
  const { values } = useFormikContext();
  const questions = values.account_type === 'entity' ? entity_questions : individual_questions;

  return (
    <>
      <H1>Background Information</H1>
      {
        questions.map((option) => (
          <FieldGroup name={option.name} key={option.name} label={option.label}>
            <RadioButton name={option.name} value="false">
              No
            </RadioButton>
            <RadioButton name={option.name} value="true">
              Yes
            </RadioButton>
          </FieldGroup>
        ))
      }
      {
        ( values.registration_revoked === "true" ||
          values.convicted_felon === "true" ||
          values.misdemeanor === "true" ||
          values.under_investigation === "true" ) &&
        <IndentTextArea>
          <TextArea
            name="background_details"
            placeholder="Please specify the details to your answer above."
            required
          >
          </TextArea>
        </IndentTextArea>
      }
    </>
  );
};

export default BackgroundInfo;
